import { useEffect } from "react";
export function usePageTitle(name) { useEffect(() => { document.title = name; return () => { if (document.title === name) {
    document.title = "Tykel";
} }; }, [name]); }
export function titleHelperClip(value, length) { if (!value)
    return "..."; if (value.length <= length)
    return value; return value.slice(0, length) + "..."; }
export function PageTitle(props) { usePageTitle(props.title); return null; }
